<template>
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.90909 4.59636V3.04C6.92471 2.2516 6.62739 1.4891 6.0822 0.919377C5.537 0.349649 4.78833 0.0190785 4 0C3.21167 0.0190785 2.463 0.349649 1.9178 0.919377C1.37261 1.4891 1.07529 2.2516 1.09091 3.04V4.59636H0V10.7782C0 10.9711 0.0766231 11.1561 0.213013 11.2924C0.349403 11.4288 0.534388 11.5055 0.727273 11.5055H7.27273C7.46561 11.5055 7.6506 11.4288 7.78699 11.2924C7.92338 11.1561 8 10.9711 8 10.7782V4.59636H6.90909ZM4.36364 8.31636V9.32364H3.63636V8.28364C3.45933 8.19254 3.31876 8.04366 3.23798 7.86168C3.15721 7.6797 3.14108 7.47558 3.19228 7.28317C3.24348 7.09077 3.35893 6.92166 3.51947 6.8039C3.68001 6.68614 3.87599 6.62681 4.07489 6.63576C4.27379 6.64471 4.46365 6.7214 4.61296 6.85311C4.76228 6.98481 4.86207 7.16361 4.89578 7.35983C4.9295 7.55605 4.8951 7.75791 4.79831 7.93189C4.70152 8.10588 4.54814 8.24154 4.36364 8.31636ZM6.18182 4.59636H1.81818V3.04C1.8025 2.44445 2.02318 1.8669 2.432 1.43355C2.84082 1.00021 3.40455 0.746284 4 0.727273C4.59545 0.746284 5.15918 1.00021 5.568 1.43355C5.97682 1.8669 6.1975 2.44445 6.18182 3.04V4.59636Z"
      fill="#C4C4C4"
    />
  </svg>
</template>

<script>
export default {
  name: "LockIcon"
};
</script>
